import { useEffect } from 'react'
import { MobilePromotionFormData } from 'src/helpers/mobilePromotionFormValidation'

const InvalidFieldScroll = ({
  submitFailed,
  errors
}: {
  submitFailed: boolean
  errors: Partial<MobilePromotionFormData>
}): null => {
  const [firstError] = Object.keys(errors)

  useEffect(() => {
    if (!submitFailed || typeof firstError !== 'string') {
      return
    }
    document.querySelector(`[data-field="${firstError}"]`)?.scrollIntoView({ block: 'center' })
  }, [submitFailed, firstError])

  return null
}

export default InvalidFieldScroll
